export const UpsellingActiveStyles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    header: {
        display: 'flex',
        marginBottom: 20,
        justifyContent: 'center',
    },
    subtitleContainer: {
        display: 'flex',
        marginBottom: 20,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    },
    textContainer: { maxWidth: 600 },
    actions: { marginBottom: 20 },
    btn: {
        backgroundColor: '#74BE00',
        cursor: 'pointer',
        borderRadius: 50,
        width: 211,
        height: 36,
    },
    IconCheckGreenStyle: {
        position: 'absolute',
        left: -50,
        top: 3,
    },
}
